module.exports = __webpack_public_path__ + "media/images/icon/icons8-Open in Window-145ecbdddd3fae13731c3d2cb54169a9.png";